import React from 'react';
import $ from 'jquery';

import TettraEditor from '../../tettra-editor/components/TettraEditor';
import { pageToEditorState } from '../../tettra-editor/utilities/contentToEditorState';
import { getPageUrlFromPageId } from '../../utilities/urlHelper';

const PageTitle = ({ page }) => {
    const { category_id, folder_id } = page;
    if (!category_id || !window.categoriesAndFoldersMap) {
        return (
            <h1>{page.title}</h1>
        );
    }

    const categoryName = window.categoriesAndFoldersMap[category_id].name;
    if (!folder_id) {
        return (
            <div>
                <h1 className="mb1">
                    {page.title}
                </h1>
                <p className="gray">
                    {' in '}
                    {categoryName}
                </p>
            </div>
        );
    }

    const folderName = window.categoriesAndFoldersMap[category_id].folders[folder_id].name;
    return (
        <div>
            <h1 className="mb1">
                {page.title}
            </h1>
            <p className="gray">
                {' in '}
                {categoryName}
                <span className="breadcrumb-separator"> / </span>
                {folderName}
            </p>
        </div>
    );
};

class PagePreviewModal extends React.Component {
    state = {
        page: this.props.page,
    };

    componentDidMount() { return this.getPagePreview(); }

    getPagePreview = () => {
        const { page } = this.state;

        if (page.editor_state || page.html) return;
        if (this.activeRequest) this.activeRequest.abort();

        this.activeRequest = $.get(`/api/teams/${window.teamId}/pages/${page.id}?preview=true`);

        return this.activeRequest
            .done(({ page }) => this.setState({ page }));
    };

    onClickModal = ({ target: { className } }) => {
        if (className.includes('react-modal open fullscreen')) {
            this.props.closeModal();
        }
    };

    render() {
        const { page } = this.state;
        const editorState = pageToEditorState(page);
        const config = { readOnly: true, editorIdentifier: 'PagePreviewModal' };

        return (
            <div className="react-modal open fullscreen" onMouseDown={this.onClickModal}>
                <div className="modal-content">
                    <PageTitle page={page} />
                    <div id="post-html-container" className="modal-content__body">
                        {editorState && <TettraEditor editorState={editorState} config={config} /> }
                        {!editorState && <span className="gray loading">Loading page preview..</span>}
                    </div>
                    <div className="mt2 right-align">
                        <a href={getPageUrlFromPageId(page.id)} className="react-modal-close btn-secondary mr2">View page</a>
                        <span className="react-modal-close btn-secondary mr2" onClick={this.props.closeModal}>Close</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default PagePreviewModal;
